import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { AppraisalService } from '../services/appraisal.service';

@Component({
  selector: 'app-set-nsu-l2',
  templateUrl: './set-nsu-l2.component.html',
  styleUrls: ['./set-nsu-l2.component.css']
})
export class SetNsuL2Component implements OnInit {

   employee_code;
   emplyoeeCodeData;
  
   l2_dd;
  showAppraisalForm = false;
  message = '';
  constructor(private route: ActivatedRoute, private apprais : AppraisalService, private router: Router) { }
  clickStatus = false;
  alreadySubmit = false;

  userData = {
    employee_code : '',
    employee_name : '',
    assign_l2_code : '',
    form_type : '',
    employee_qualification :'',
    employee_designation : '',
    employee_department : '',
    employee_division : '',
    employee_grade : '',
    employee_DOB : '',
    employee_DOA : '',
    employee_LPM : '',
  }


  ngOnInit() {
    this.employee_code = this.route.snapshot.params.employee_code;
    //console.log(this.employee_code);
    this.emplyoeeCodeData = {
      employee_code: this.employee_code,
    }
    this.apprais.getNsuAndL2(this.emplyoeeCodeData).subscribe(res=>{
      //console.log(res);
      this.userData.employee_code = res.user.employee_code;
      this.userData.employee_name = res.user.employee_name;
      this.userData.form_type = '2';
      this.userData.employee_qualification = res.user.qualification;
      this.userData.employee_designation = res.user.designation;
      this.userData.employee_department = res.user.department_name;
      this.userData.employee_division = res.user.division;
      this.userData.employee_grade = res.user.grade;
      this.userData.employee_DOB = this.dateFun(res.user.DOB);
      this.userData.employee_DOA = this.dateFun(res.user.DOA);
      this.userData.employee_LPM = this.dateFun(res.user.LPM);
      this.userData.assign_l2_code = res.user.assign_l2_code;
      this.l2_dd = res.l2dd;
      this.showAppraisalForm = res.showAppraisalForm;
      this.message = res.message;
   
  });
    
  }
  
dateFun(dateStr)
  {
    var dateObj = new Date(dateStr);
    var month = dateObj.getMonth()+1; //months from 1-12
    var day = dateObj.getDate();
    var year = dateObj.getFullYear();
    
    var newdate = year + "-" + month + "-" + day;
    //var newdate = day + "/" + month + "/" + year;
    //console.log(newdate);
    return newdate;
    
  }
  isValid(assignL2Form,control) 
  {
   
    if((!assignL2Form.controls[control].valid && (assignL2Form.controls[control].dirty ||assignL2Form.controls[control].touched)) || (!assignL2Form.controls[control].valid && this.clickStatus))
    {
       //var errorStr = '<div class="alert alert-danger"> * ' + control+ ' is required</div>';
       var errorStr = '<div class="alert alert-danger"> * ' + 'This field is required</div>';
      return errorStr;
    }
  }

  onSubmit(assignL2Form)
  {
    this.clickStatus = true;
    if(assignL2Form.valid)
    {
     this.alreadySubmit = true;
     //console.log(this.userData);
     var setrole = this.apprais.setNsuL2Code(this.userData).subscribe( res => {
      localStorage.setItem('assign_l2_msg',res.message);
      this.router.navigate(['/nsuAssignL2']);
     })
     
      
    }
   
   
  }

}



// WEBPACK FOOTER //
// ./src/app/set-nsu-l2/set-nsu-l2.component.ts